import Vue from 'vue'
import Router from 'vue-router'

import Auth from '@app/auth/routes'
import Dashboard from '@app/dashboard/routes'
import Extract from '@app/extract/routes'
import Proposal from '@app/proposals/routes'
import User from '@app/user/routes'
import Profile from '@app/profile/routes'
import Clients from '@app/clients/routes'
import ImportInvoices from '@app/import_invoices/routes'
import CompleteAssignors from '@app/steps/routes'
import AssignmentRequests from '@app/assignment_request/routes'
import AntecipationRequests from '@app/antecipation_request/routes'
import FollowUp from '@app/follow_up/routes'
import Assignments from '@app/assignments/routes'
import Management from '@app/management/routes'
import Tokens from '@app/tokens/routes'
import Confirmation from '@app/confirmation/routes'
import PayerAssignors from '@app/payer_assignors/routes'
import Abc from '@app/abc/routes'

// routes payer
import PayerAssignmentRequest from '@app/payer/assignment_requests/routes'
import PayerContacts from '@app/payer_contacts/routes'

import store from '@/store'
import {getAccessToken} from '@utils/auth'
import localforage from 'localforage'

const NotFound = () => import('@/errors/404')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    ...Profile,
    ...Auth,
    ...Dashboard,
    ...Proposal,
    ...User,
    ...Clients,
    ...ImportInvoices,
    ...CompleteAssignors,
    ...AssignmentRequests,
    ...FollowUp,
    ...Assignments,
    ...Management,
    ...Tokens,
    ...Confirmation,
    ...PayerAssignors,
    ...PayerAssignmentRequest,
    ...PayerContacts,
    ...Abc,
    ...AntecipationRequests,
    ...Extract,
    {
      path: '*',
      name: 'errors.not_found',
      component: NotFound,
      meta: {requiresAuth: true}
    }
  ],
  scrollBehavior () {
    return {x: 0, y: 0}
  }
})

const checkAuth = async (to, from, next) => {
  const token = await getAccessToken()
  store.dispatch('setToken', {token})

  if (token === null) {
    next({name: 'auth.login'})
  }
  next()
}

const checkPermission = async (to, from, next) => {
  const userPermissions = store.state.permissions.list
  const routePermissions = to.meta.permissions
  const storedPermissions = await localforage.getItem('current_permissions')
  if (userPermissions.some(role => routePermissions.includes(role)) || storedPermissions.some(role => routePermissions.includes(role))) {
    next()
  } else {
    next({name: 'dashboard.index'})
  }
}

router.beforeEach((to, from, next) => {
  if (!to.meta.requiresAuth) {
    next()
  } else {
    checkAuth(to, from, next)
    if (to.meta.permissions) {
      checkPermission(to, from, next)
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js